import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Property } from "@/types/property";

export const useHostProperties = () => {
  return useQuery({
    queryKey: ["host-properties"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      const { data, error } = await supabase
        .from("properties")
        .select(`
          *,
          bookings (
            id,
            check_in_date,
            check_out_date,
            status,
            total_price,
            created_at
          )
        `)
        .eq('host_id', user.id)
        .order('created_at', { ascending: false });

      if (error) throw error;
      
      // Cast the JSON fields to the correct types
      return data.map(property => ({
        ...property,
        amenities: property.amenities as Record<string, any>,
        accepted_payment_methods: property.accepted_payment_methods as Record<string, any>,
        cancellation_policy: property.cancellation_policy as Record<string, any>
      })) as Property[];
    }
  });
};